import { PageTemplateContent, SkeletonLoading } from 'app/common/templates-next/page-template'


export const CompensationInfoLoading = () => {
  return (
    <PageTemplateContent>
      <SkeletonLoading rows={3} />
    </PageTemplateContent>
  )
}
